export function minMax(values: number[]) {
    let min = values[0];
    let max = values[0];

    for (const value of values) {
        if (value < min) min = value;
        if (value > max) max = value;
    }

    return [min, max];
}

export function scaleLevel(v: number) {
    if (v >= 0 && v <= 1) {
        return Math.trunc(v * 100);
    } else {
        return v;
    }
}
